interface drawOptions {
    times?: number;
    days?: number;
    news?: number;
    integrals?: number;
    amount?: number | string;
    tag?: string;
    noData?: boolean;
    sucessCallback: (url: string) => void;
    errCallback: () => void;
}

interface textOptions {
    value: string,
    unit: string,
    relate: string,
    num: number
}

export default class Draw {
    public options: null | drawOptions = null
    public texts: textOptions[] = [
        {
            value: '这一年，你总共打开封面新闻',
            unit: '次',
            relate: 'times',
            num: 0
        },
        {
            value: '累计使用封面新闻',
            unit: '天',
            relate: 'days',
            num: 0
        },
        {
            value: '累计观看新闻',
            unit: '篇',
            relate: 'news',
            num: 0
        },
        {
            value: '累计获得积分',
            unit: '分',
            relate: 'integrals',
            num: 0
        },
    ]
    public result: string = ''
    public fontFamily: string = '"Helvetica", "PingFang SC", "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif'

    constructor (options: drawOptions) {
        this.options = options
        this.init()
    }

    init () {
        const options = this.options as drawOptions
        const c: HTMLCanvasElement = document.createElement('canvas')
        const ctx = c.getContext('2d') as CanvasRenderingContext2D
        Promise.all([this.loadImage(require(!options.noData ? '@/assets/img/share_bg.jpg' : '@/assets/img/share_new_user.jpg')), this.loadImage(require('@/assets/img/ercode_img.png'))]).then((imgs: any) => {  
            if (!options.noData) {
                this.hasDataDraw(c, ctx, imgs)
            } else {
                c.width = imgs[0].width
                c.height = imgs[0].height
                ctx.drawImage(imgs[0], 0, 0, imgs[0].width, imgs[0].height, 0, 0, c.width, c.height)
                ctx.drawImage(imgs[1], 0, 0, imgs[1].width, imgs[1].height, 900, 1674, 125, 125)
            }

            if (options.amount) {
                ctx.font = `25px ${this.fontFamily}`
                ctx.textAlign = 'left'
                ctx.textBaseline = 'top'
                ctx.fillStyle = '#fff'
                ctx.fillText('你获得的封面红包', 25, 1830)
                ctx.font = `bold 40px ${this.fontFamily}`
                ctx.textAlign = 'left'
                ctx.textBaseline = 'top'
                ctx.fillStyle = '#fff'
                ctx.fillText(`￥${options.amount}`, 242, 1825)
            }
            this.result = c.toDataURL('image/jpeg')
            options.sucessCallback(this.result)
        }).catch((err) => {
            options.errCallback()
        })
    }

    hasDataDraw (c: HTMLCanvasElement, ctx: CanvasRenderingContext2D, imgs: HTMLImageElement[]) {
        const options = this.options as drawOptions
        c.width = imgs[0].width
        c.height = imgs[0].height
        ctx.drawImage(imgs[0], 0, 0, imgs[0].width, imgs[0].height, 0, 0, c.width, c.height)
        ctx.drawImage(imgs[1], 0, 0, imgs[1].width, imgs[1].height, 900, 1674, 125, 125)
        let T = 470
        let L = 122
        for (let val of this.texts) {
            const num = options[val.relate]
            let left: number = 0
            if (num) {
                ctx.font = `40px ${this.fontFamily}`;
                ctx.textAlign = 'left'
                ctx.textBaseline = 'top'
                ctx.fillStyle = '#000'
                ctx.fillText(val.value, L, T)
                T += 80
                ctx.font = `bold 40px ${this.fontFamily}`
                ctx.textAlign = 'left'
                ctx.textBaseline = 'top'
                ctx.fillStyle = '#ff3437'
                ctx.fillText(num, L, T)
                left = ctx.measureText(num).width
                ctx.font = `40px ${this.fontFamily}`
                ctx.textAlign = 'left'
                ctx.textBaseline = 'top'
                ctx.fillStyle = '#000'
                ctx.fillText(val.unit, L + left, T)
                T += 85
            }
        }

        ctx.font = `40px ${this.fontFamily}`
        ctx.textAlign = 'left'
        ctx.textBaseline = 'top'
        ctx.fillStyle = '#000'
        ctx.fillText('你的2020年封面标签是', L, T + 65)
        ctx.font = `bold 83px ${this.fontFamily}`
        ctx.textAlign = 'left'
        ctx.textBaseline = 'top'
        ctx.fillStyle = '#ff3437'
        let tag = options.tag || ''
        ctx.fillText(tag, L, T + 150)
    }

    loadImage (url: string) {
        return new Promise((resolve) =>{
            const img = new Image()
            img.crossOrigin = 'Anonymous' 
            img.src = url
            img.addEventListener('load', () => {
                resolve(img)
            })
        })
    }
}